











import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class LoadingAnimationWithoutBg extends Vue {
  @Prop({ default: 'A' }) private mode!: string
  private modefire = ''
  private mounted() {
    if (this.mode === 'B') {
      this.modefire = '--icon'
    }
  }
}
